module.exports = __webpack_public_path__ + "static/media/DSC_0434.320ab66e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0434.jpg
// module id = 601
// module chunks = 0